<script>
import { productBrandService } from "../../services";
import { required , requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { routes } from "../../config/api_routes";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
    components: { productBrandService,Layout,PageHeader,DropzonePopup},
    data() {
        return {
            is_disable: false,
            isShowInWebDisabled: false, 
            url: null,
            config: config,
            typeform: {
                name: "",
                image:"",
                name_lang: "",
                status: "1",
                show_in_website : "1"
            },
            brand_image: "",
            brand_image_path: "",
            brand_image_delete_url: routes.brandImageDeleteUrl,
        };
    },
    validations: {
        typeform: {
            name:{
                required,
            },
            name_lang: {
                required
            },
            image: {
                required: requiredIf(function (nestedModel) {
                return !(!!this.brand_image || !!this.typeform.image);
                }),
            }
        },
    },
    mounted(){
        this.getProducerBrandById();
    },
    watch: {
        'typeform.status'(newStatus) {
            if (newStatus === '0') {  // Status is inactive
                this.typeform.show_in_website = '0';  // Set 'show_in_website' to inactive
                this.isShowInWebDisabled = true;  // Disable the "Show in Web" toggle
            } else {
                this.isShowInWebDisabled = false;  // Enable the "Show in Web" toggle when status is active
            }
        },
        // 'brand_image'(newVal) {
        //     this.checkImageAvailability();
        // },
        // 'typeform.image'(newVal) {
        //     this.checkImageAvailability();
        // },
    },
    methods: {
        
        getProducerBrandById(){
            productBrandService.getProducerBrandById({id: this.$route.params.id, type:'edit' })
            .then(response => {
                const{ id, producer_company_id, name, name_lang, status,show_in_website } = response.data.result;
                this.brand_image_path = response.data.result.brand_image_path;
                this.brand_image = response.data.result.image;
                this.typeform = { id, producer_company_id, name, name_lang, status,show_in_website};
            });
            
        },
        editProducerBrand(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            } else {
                this.is_disable = true;
                productBrandService.editProducerBrand(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        this.$router.push({ name: "producer-brand-list",params: { producer_id: this.base64(this.typeform.producer_company_id) }});
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                    this.is_disable = false;
                });
            }
        },

        onBrandImagedeleted(value) {
            this.brand_image = "";
        },
        // base64(str) {
        //     return btoa(unescape(encodeURIComponent(str)));
        // },
        // validateImageBeforeNavigation(event) {
        //     // Trigger validation on the image field
        //     this.$v.typeform.image.$touch(); // Manually touch the image field to show validation error
            
        //     // Run check for image availability
        //     this.checkImageAvailability();

        //     // If image is invalid, prevent navigation and show the validation message
        //     if (this.$v.typeform.image.$invalid) {
        //         error_message('Please select image'); // Show validation message
        //         event.preventDefault(); // Prevent the navigation
        //         return;
        //     } else {
        //         // If validation passes, proceed with navigation
        //         this.imageIsValid = true; // Proceed with navigation
        //         this.$router.push({
        //             name: 'producer-brand-list',
        //             params: { producer_id: this.base64(this.typeform.producer_company_id) }
        //         });
        //     }
        // },
        // checkImageAvailability() {
        //     // Disable the submit button if image is missing (both brand_image and typeform.image are empty)
        //     if (!this.brand_image && !this.typeform.image) {
        //         this.is_disable = true;
        //     } else {
        //         this.is_disable = false;
        //     }
        // }
    },
};

</script>
<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left avatar-main-icon">
                        <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-briefcase"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18">{{ typeform.name }}</h4>
                            <router-link :to="{name:'producer-brand-list', params: {producer_id:base64(this.typeform.producer_company_id)}}">{{ trans.get('__JSON__.Producer Brands') }}</router-link>

                            <!-- <p>
                                <a
                                    
                                    :class="{ 'disabled-link': !this.typeform.image && !this.brand_image }"
                                    @click.prevent="validateImageBeforeNavigation">
                                    {{ trans.get('__JSON__.Producer Brands') }}
                            </a>
                                
                                > {{ typeform.name }}
                            </p>  -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="editProducerBrand">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">{{ trans.get('__JSON__.Brand Information') }}</h4>
                            <p class="card-title-desc"></p>
                            <div class="row">

                                <div class="col-sm-6" v-if="$auth.setting">
                                    <div class="form-group">
                                    <label class="required">{{ trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })}}</label>
                                        <input
                                            id="name"
                                            v-model="$v.typeform.name.$model"
                                            type="text"
                                            class="form-control"
                                            :placeholder="trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })"
                                            name="name"
                                            :class="{ 'is-invalid': $v.typeform.name.$error }"
                                        />
                                        <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                                    <div class="form-group">
                                    <label class="required">{{ trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })}}</label>
                                        <input
                                            id="name_lang"
                                            v-model="$v.typeform.name_lang.$model"
                                            type="text"
                                            class="form-control"
                                            :placeholder="trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })"
                                            name="name_lang"
                                            :class="{ 'is-invalid': $v.typeform.name_lang.$error }"
                                        />
                                        <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6 vendor-status">
                                    <b-form-group
                                        id="input-group-1"
                                        :label="trans.get('__JSON__.Status')"
                                        label-for="status"
                                        >
                                        <label class="switch">
                                            <input
                                            type="checkbox"
                                            id="togBtn"
                                            name="status"
                                            v-model="typeform.status"
                                            class="switch-on"
                                            true-value="1"
                                            false-value="0"
                                            />
                                            <div class="slider round">
                                            <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                            <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                            </div>
                                        </label>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-6 vendor-status">
                                    <b-form-group
                                        id="input-group-1"
                                        :label="trans.get('__JSON__.Show In Web')"
                                        label-for="show in web"
                                        >
                                        <label class="switch">
                                            <input
                                            type="checkbox"
                                            id="togBtn"
                                            name="show_in_website"
                                            v-model="typeform.show_in_website"
                                            :disabled="isShowInWebDisabled"
                                            class="switch-on"
                                            true-value="1"
                                            false-value="0"
                                            />
                                            <div class="slider round">
                                            <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                            <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                            </div>
                                        </label>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                    <label class="required">{{ trans.trans('__JSON__.Image')}}</label>
                                        <dropzone-popup
                                            v-model="$v.typeform.image.$model"
                                            type="file"
                                            id="image"
                                            name="image"
                                            acceptedFiles=".jpeg,.jpg,.png"
                                            :editable-images="brand_image"
                                            :media-path="brand_image_path+'/original'"
                                            :delete-path="brand_image_delete_url"
                                            @image-deleted="this.onBrandImagedeleted"
                                            :class="{ 'is-invalid': $v.typeform.image.$error }"
                                        />
                                        <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                                        <span v-if="!$v.typeform.image.required" >{{ trans.get('__JSON__.Please select image') }}.</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                                    <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                                    <router-link
                                        :to="{name:'producer-brand-list', params: {producer_id:base64(this.typeform.producer_company_id)}}"
                                    >
                                        <b-button
                                            type="button" 
                                            variant="secondary" 
                                            class="mt-3">
                                            {{ trans.get('__JSON__.Cancel') }}
                                        </b-button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>